import React, { Component, useLayoutEffect } from 'react';
import ReactDOM from 'react-dom';

import { CONTEXT_PATH } from '@confluence/named-routes/entry-points/context.ts';

import { ProfileCardWrapper } from './ProfileCardWrapper.tsx';
import { replaceUserElementsWithPlaceholders, getAtlassianPeopleProfileUrl } from './helpers.ts';

/**
 * This component processes the DOM Node for ContentBody, Likes, & CommentBody to find all User Mentions
 * and User Links and replaces them with a React Element for @atlaskit/profilecard
 */
const LEGACY_USER_ELEMENT_SELECTORS = [
	'a.user-mention',
	'a.confluence-userlink',
	'a.userLogoLink',
	'span.user-hover-trigger',
	'img.confluence-userlink',
];

export class LegacyUserElementsHover extends Component<any> {
	shouldComponentUpdate(nextProps: any): boolean {
		return nextProps.node !== this.props.node;
	}

	getLegacyUserElements(): Element[] {
		const { node } = this.props;
		if (!node) {
			return [];
		}

		return Array.from(node.querySelectorAll(LEGACY_USER_ELEMENT_SELECTORS.join(',')));
	}

	renderPortal = (item: any) => {
		const { position } = this.props;
		const userId = item.props['data-account-id'];

		item.props.href = getAtlassianPeopleProfileUrl(
			item.props['data-account-id'],
			null,
			CONTEXT_PATH,
		);

		return ReactDOM.createPortal(
			<MarkPlaceholderIgnoredWrapper placeholder={item.placeholder}>
				<ProfileCardWrapper isAnonymous={!userId} userId={userId} position={position}>
					{/* eslint-disable-next-line @atlaskit/design-system/no-html-anchor */}
					<a {...item.props}>{item.props.children}</a>
				</ProfileCardWrapper>
			</MarkPlaceholderIgnoredWrapper>,
			item.placeholder,
		);
	};

	render() {
		return replaceUserElementsWithPlaceholders(this.getLegacyUserElements()).map((item: any) =>
			this.renderPortal(item),
		);
	}
}

export function MarkPlaceholderIgnoredWrapper({
	placeholder,
	children,
}: {
	placeholder: HTMLElement;
	children: React.ReactNode;
}): React.JSX.Element {
	useLayoutEffect(() => {
		const markPlaceholderIgnored = (e: HTMLElement | null) => {
			if (e?.tagName === 'SPAN') {
				e.setAttribute('data-ssr-placeholder-ignored', 'true');
				Array.from(e.children).forEach((child) => markPlaceholderIgnored(child as HTMLElement));
			}
		};

		markPlaceholderIgnored(placeholder);
	}, [placeholder]);

	return <>{children}</>;
}
